export class Message {

    constructor(
        public uid: string,
        public message: string,
        public from: string,
        public from_uid: string,
        public date: Date,
        public seen: boolean,
        public order: number,
        public from_avatar: string,
      ) { }
}
